<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false>
			<p slot="title">会员卡管理</p>
		</sub-ibox-title>
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Vip',
		data() {
			return {
				tabbarList: [{
					title: '会员卡',
					routeName: 'vipManage'
				},
//				{
//					title: '数据分析',
//					routeName: 'vipStatistics'
//				},{
//					title: '会员管理',
//					routeName: 'vipMember'
//				}
				]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Index.vue?5424a8ea